import { UploadedFile } from '@paragon/component-processor';
import { addSpinnerMessage, removeSpinnerMessage } from '@paragon/task-spinner';

import { compare } from '../data/convertCompareCount';
import { setComparisonResults } from '../store/comparisonResultsSlice';
import { AsyncThunkActionVoid } from './thunkActions';

export const compareFiles =
  (fileSetOne: readonly UploadedFile[], fileSetTwo: readonly UploadedFile[]): AsyncThunkActionVoid =>
  async (dispatch) => {
    const spinnerId = dispatch(addSpinnerMessage('Comparing files...'));

    const { preparedFileSetOne, preparedFileSetTwo } = await prepareFileDataForComparison(fileSetOne, fileSetTwo);
    const comparisonResults = await compare(preparedFileSetOne, preparedFileSetTwo).catch(() => {
      alert('Error comparing.');
      dispatch(removeSpinnerMessage(spinnerId));
    });

    if (comparisonResults != null) {
      dispatch(setComparisonResults(comparisonResults));
    }

    dispatch(removeSpinnerMessage(spinnerId));
  };

async function prepareFileDataForComparison(fileSetOne: readonly UploadedFile[], fileSetTwo: readonly UploadedFile[]) {
  const fileSetOneGetContents = fileSetOne.map((file) => file.getContents());
  const fileSetTwoGetContents = fileSetTwo.map((file) => file.getContents());
  await Promise.all([...fileSetOneGetContents, ...fileSetTwoGetContents]);

  const mapFileToPreparedFile = (file: UploadedFile) => ({
    name: file.filename,
    fileType: file.filetype!,
    base64Contents: file.contents!,
  });
  const preparedFileSetOne = fileSetOne.map(mapFileToPreparedFile);
  const preparedFileSetTwo = fileSetTwo.map(mapFileToPreparedFile);

  return {
    preparedFileSetOne,
    preparedFileSetTwo,
  };
}
